<div class="tab-page">
    <div class="toolbar">
        <h3>Usuários</h3>
        <button type="button" mat-stroked-button color="primary" (click)="openCreateUserDialog()">
            <mat-icon>person_add</mat-icon>
            Novo
        </button>
    </div>

    @if (associatedUsers$ | async; as users) { @if (users.length > 0) {
    <div class="table">
        <div class="thead">
            <span>Nome</span>
            <span>E-mail</span>
            <span class="actions-h"></span>
        </div>
        @for (user of users; track user) {
        <div class="row">
            <div class="name">
                <span class="av">{{ userInitials(user) }}</span>
                <b>{{ user.firstName }} {{ user.lastName }}</b>
            </div>
            <div class="mail">{{ user.email || '—' }}</div>
            <div class="actions">
                <button
                    type="button"
                    mat-icon-button
                    color="primary"
                    (click)="openEditUserDialog(user)"
                    aria-label="Editar usuário"
                >
                    <mat-icon>edit</mat-icon>
                </button>
            </div>
        </div>
        }
    </div>
    } @else {
    <p class="empty">Nenhum usuário associado a este controlador.</p>
    } } @else {
    <div class="loading"><mat-spinner diameter="32"></mat-spinner></div>
    }
</div>
